export function redirectWindowLocation(url: string) {
  window.location.href = url;
}
